import { Box } from "@mui/material";
import appStoreQrCode from "../assets/images/appstore.jpg";
import googlePlayQrCode from "../assets/images/playstore.jpg";

/** Keep each image encoding the same listing as `STORE_URLS`. */
const QR_CODES = {
  appStore: appStoreQrCode,
  googlePlay: googlePlayQrCode,
};

/** A scannable code for the Echo listing in `store`. */
const StoreQrCode = ({ store, title, size = 112 }) => (
  <Box
    component="img"
    src={QR_CODES[store]}
    alt={title}
    sx={{ display: "block", width: size, height: size, objectFit: "contain" }}
  />
);

export default StoreQrCode;
